/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
enum UserAgent {
    MSIE = 'MSIE',
    CHROME = 'Chrome',
    FIREFOX = 'Firefox',
    SAFARI = 'Safari',
    EDGE = 'Edge',
    MACEDGECLIENT = 'MacEdgeClient',
}

enum OS {
    ANDROID = 'Android',
    IOS = 'iOS',
    LINUX = 'Linux',
    MACOS = 'Mac OS',
    WINDOWS = 'Windows',
    UNKNOWN = 'unknown',
}

const UA_CHECKERS = [
    {
        re: /\bEdge\/([.0-9]+)/,
        type: UserAgent.EDGE,
    },
    {
        // MacOS 13.3 Edgeclient Issue
        re: /\bMacEdgeClient\/([.0-9]+)/,
        type: UserAgent.MACEDGECLIENT,
    },
    {
        re: /\bTrident\b.*\brv:([.0-9]+)/,
        type: UserAgent.MSIE,
    },
    {
        re: /;\s+MSIE\s+([.0-9]+)/,
        type: UserAgent.MSIE,
    },
    {
        re: /\bChrom(?:e|ium)\/([.0-9]+)/,
        type: UserAgent.CHROME,
    },
    {
        re: /\bFirefox\/([.0-9]+)/,
        type: UserAgent.FIREFOX,
    },
    {
        re: /\bVersion\/([.0-9]+).*\bSafari\//,
        type: UserAgent.SAFARI,
    },
    {
        // fallback for everything that pretends to be Safari
        re: /\bSafari\/([.0-9]+)/,
        type: UserAgent.SAFARI,
    },
    {
        // Office App Safari
        re: /Macintosh.*AppleWebKit/,
        type: UserAgent.SAFARI,
    },
];
const OS_CHECKERS = [
    {
        re: /\bAndroid\s+([.0-9]+);/,
        type: OS.ANDROID,
    },
    {
        re: /(?:iPad|iPhone).*\s+OS\s+([._0-9]+)/,
        type: OS.IOS,
    },
    {
        re: /Mac OS X ([._0-9]+)/,
        type: OS.MACOS,
    },
    {
        re: /\bLinux\b/,
        type: OS.LINUX,
    },
    {
        re: /\bWindows\s+NT\s+([.0-9]+)/,
        type: OS.WINDOWS,
    },
];

class UserAgentParser {
    readonly family: UserAgent = UserAgent.MSIE;
    readonly rawVersion: string = '';
    readonly version: number | null = null;
    readonly os: OS = OS.UNKNOWN;
    readonly osVersion: string = '';

    constructor(uaString: string) {
        for (const entry of UA_CHECKERS) {
            const m = entry.re.exec(uaString);
            if (m) {
                this.family = entry.type;
                this.rawVersion = (m[1] || '').replace(/_/g, '.');
                this.version = this.rawVersion ? parseInt(this.rawVersion, 10) : null;
                break;
            }
        }
        for (const entry of OS_CHECKERS) {
            const m = entry.re.exec(uaString);
            if (m) {
                this.os = entry.type;
                this.osVersion = (m[1] || '').replace(/_/g, '.');
                break;
            }
        }
        /*
        console.log(`User-Agent: ${this.family} ${this.version} (${this.rawVersion}) ` +
                    `on ${this.os} ${this.osVersion}`);
        */
    }

    public is(type: UserAgent): boolean {
        return this.family === type;
    }
}

const userAgentString = typeof navigator !== 'undefined' ? navigator.userAgent : '';
const userAgent = new UserAgentParser(userAgentString);

export { OS, UserAgent, UserAgentParser, userAgent, userAgent as default };
